import { render, staticRenderFns } from "./MyTickets.vue?vue&type=template&id=2416f605&"
import script from "./MyTickets.vue?vue&type=script&lang=ts&"
export * from "./MyTickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports